import { useState } from "react";
import image1 from "./assets/image1.jpg";
import image2 from "./assets/image2.jpg";
import image3 from "./assets/image3.jpg";
import image4 from "./assets/image4.jpg";
import image5 from "./assets/image5.jpg";
import image6 from "./assets/image6.jpg";

export const WhoWeAre = () => {
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [image1, image2, image3, image4, image5, image6];

  const handleClick = (image: any, index: number) => {
    setSelectedImage(image);
    setCurrentImageIndex(index);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const nextIndex = (currentImageIndex + 1) % images.length;
    setSelectedImage(images[nextIndex]);
    setCurrentImageIndex(nextIndex);
  };

  const prevImage = () => {
    const prevIndex =
      currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1;
    setSelectedImage(images[prevIndex]);
    setCurrentImageIndex(prevIndex);
  };

  return (
    <div className="bg-gradient-to-br from-slate-900 via-brand-blue to-slate-800 text-white overflow-x-hidden">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-blue/20 via-transparent to-brand-yellow/20 animate-pulse"></div>
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-brand-yellow/10 rounded-full blur-3xl animate-bounce"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-brand-blue/10 rounded-full blur-3xl animate-pulse"></div>
        </div>
        <div className="relative z-10 text-center max-w-5xl px-4 py-16 md:py-20 animate-fadeInUp">
          <h1
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black font-montserrat mb-4 md:mb-6 bg-gradient-to-r from-white via-brand-yellow to-white bg-clip-text text-transparent animate-pulse"
            style={{ lineHeight: "1.2", paddingTop: "0.25rem" }}
          >
            QUEM SOMOS
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-light font-roboto mb-6 md:mb-8 max-w-3xl mx-auto leading-relaxed px-2">
            Conheça nossa história, missão e o compromisso com a transformação
            de vidas.
          </p>

          {/* Scroll Indicator */}
          <div className="animate-bounce-gentle mb-8">
            <svg
              className="w-8 h-8 text-white/70 hover:text-white transition-colors duration-300 mx-auto"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              />
            </svg>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-white text-brand-blue">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold font-montserrat mb-6 bg-gradient-to-r from-brand-blue to-brand-yellow bg-clip-text text-transparent">
              Nossa Missão
            </h2>
            <p className="text-xl font-roboto text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Acolher a vulnerabilidade e desenvolver o auto suporte.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-3xl shadow-xl">
                <h3 className="text-3xl font-bold font-montserrat mb-4 text-brand-blue">
                  Nossa História
                </h3>
                <p className="text-lg font-roboto text-gray-700 leading-relaxed">
                  A Comunidade Terapêutica PATRE, localizada em Antônio
                  Prado/RS, é uma organização sem fins lucrativos que trabalha
                  para ajudar pessoas que lutam contra a dependência química
                  (álcool e drogas) a superar seus desafios e recuperar suas
                  vidas.
                </p>
              </div>

              <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 p-8 rounded-3xl shadow-xl">
                <h3 className="text-3xl font-bold font-montserrat mb-4 text-brand-blue">
                  Nossa Equipe
                </h3>
                <p className="text-lg font-roboto text-gray-700 leading-relaxed">
                  Nossa equipe é formada por profissionais experientes e
                  dedicados, incluindo psicólogos, monitores, coordenadores,
                  voluntários e outros especialistas em saúde mental e
                  dependência química.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-slate-50 to-slate-100 p-8 rounded-3xl shadow-xl">
              <h3 className="text-3xl font-bold font-montserrat mb-4 text-brand-blue">
                Nossa Abordagem
              </h3>
              <p className="text-lg font-roboto text-gray-700 leading-relaxed mb-6">
                Valorizamos uma abordagem completa para o tratamento, isso
                significa que não vemos nossos acolhidos apenas como indivíduos
                com um problema de dependência, mas como seres humanos completos
                com uma vida emocional, física, social e espiritual.
              </p>
              <p className="text-lg font-roboto text-gray-700 leading-relaxed">
                Acreditamos que a recuperação é um processo contínuo e estamos
                comprometidos em oferecer suporte constante aos nossos acolhidos
                após o término do tratamento.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Image Gallery Section */}
      <section className="py-20 bg-gradient-to-r from-slate-800 to-slate-900">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-5xl font-bold text-center font-montserrat mb-16 bg-gradient-to-r from-brand-yellow to-white bg-clip-text text-transparent">
            Nossa Estrutura
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[image1, image2, image3, image4, image5, image6].map(
              (image, index) => (
                <div
                  key={index}
                  className="group relative overflow-hidden rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-500 hover:scale-105 cursor-pointer"
                  onClick={() => handleClick(image, index)}
                >
                  <img
                    src={image}
                    alt={`Imagem ${index + 1}`}
                    className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute bottom-4 left-4 text-white font-montserrat font-bold text-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    Ver imagem completa
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-20 bg-gradient-to-r from-brand-blue to-brand-yellow text-white">
        <div className="max-w-5xl mx-auto text-center px-4">
          <h2 className="text-5xl font-bold font-montserrat mb-8 animate-pulse">
            Temos Vagas Sociais Disponíveis!
          </h2>
          <p className="text-2xl font-roboto mb-12 max-w-3xl mx-auto leading-relaxed">
            Atendemos via municípios, SJCDH e particulares. Entre em contato e
            saiba mais sobre como podemos ajudar.
          </p>
          <a
            href="https://wa.me/5554996998885?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20Comunidade%20Terap%C3%AAutica%20Cristo%20Rei%20PATRE%20e%20gostaria%20de%20saber%20mais%20sobre%20o%20tratamento."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-brand-blue font-bold font-montserrat py-5 px-12 rounded-full text-xl uppercase tracking-wider shadow-2xl hover:shadow-white/50 transform hover:scale-110 transition-all duration-500"
          >
            Entre em Contato
          </a>
        </div>
      </section>

      {/* Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm"
          onClick={closeModal}
        >
          <div className="relative max-w-5xl max-h-[90vh] p-4">
            <button
              className="absolute -top-12 right-0 text-white text-4xl font-bold hover:text-brand-yellow transition-colors duration-300 z-60"
              onClick={closeModal}
            >
              ×
            </button>

            {/* Carousel Navigation */}
            <button
              className="fixed left-4 top-1/2 -translate-y-1/2 text-white text-4xl font-bold hover:text-brand-yellow transition-colors duration-300 bg-black/50 rounded-full w-14 h-14 flex items-center justify-center z-[9999]"
              onClick={(event) => {
                prevImage();
                event.stopPropagation();
              }}
            >
              ‹
            </button>
            <button
              className="fixed right-4 top-1/2 -translate-y-1/2 text-white text-4xl font-bold hover:text-brand-yellow transition-colors duration-300 bg-black/50 rounded-full w-14 h-14 flex items-center justify-center z-[9999]"
              onClick={(event) => {
                nextImage();
                event.stopPropagation();
              }}
            >
              ›
            </button>

            <img
              src={selectedImage}
              alt="Imagem ampliada"
              className="max-w-full max-h-full object-contain rounded-2xl shadow-2xl"
            />

            {/* Indicators */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 xl-custom:flex space-x-2 hidden">
              {images.map((_, index) => (
                <button
                  key={index}
                  className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                    index === currentImageIndex
                      ? "bg-brand-yellow"
                      : "bg-white/50"
                  }`}
                  onClick={(event) => {
                    setCurrentImageIndex(index);
                    setSelectedImage(images[index]);
                    event.stopPropagation();
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="hidden md:fixed bottom-8 right-8 bg-gradient-to-r from-brand-blue to-brand-yellow text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-500 z-50 group"
        aria-label="Voltar ao topo"
      >
        <svg
          className="w-6 h-6 transform group-hover:-translate-y-1 transition-transform duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>
    </div>
  );
};
